import { apiClient } from "./api-client";

// Tenant management (BLK-API-018) — mirrors AdminTenantController
// (/admin/api/v1/tenants), gated hasAuthority('ADMIN_LEVEL_BOOTSTRAP_SUPER').
// The reserved __PLATFORM__ tenant is hidden from listings and immutable.

export interface AdminTenantView {
  id: string;
  code?: string;
  displayName?: string;
  domain?: string;
  primaryLocale?: string;
  primaryCurrency?: string;
  timezone?: string;
  active?: boolean;
}

export interface CreateTenantInput {
  code: string;
  displayName: string;
  domain?: string;
  primaryLocale?: string;
  primaryCurrency?: string;
  timezone?: string;
}

export interface UpdateTenantInput {
  displayName?: string;
  domain?: string;
}

const BASE = "/admin/api/v1/tenants";

export function listTenants(): Promise<AdminTenantView[]> {
  return apiClient.request<AdminTenantView[]>(BASE);
}

export function getTenant(id: string): Promise<AdminTenantView> {
  return apiClient.request<AdminTenantView>(`${BASE}/${id}`);
}

export function createTenant(input: CreateTenantInput): Promise<AdminTenantView> {
  return apiClient.request<AdminTenantView>(BASE, { method: "POST", body: input });
}

export function updateTenant(id: string, input: UpdateTenantInput): Promise<AdminTenantView> {
  return apiClient.request<AdminTenantView>(`${BASE}/${id}`, { method: "PATCH", body: input });
}

export function activateTenant(id: string): Promise<AdminTenantView> {
  return apiClient.request<AdminTenantView>(`${BASE}/${id}/activate`, { method: "POST" });
}

export function deactivateTenant(id: string): Promise<AdminTenantView> {
  return apiClient.request<AdminTenantView>(`${BASE}/${id}/deactivate`, { method: "POST" });
}
